export default __webpack_public_path__ + "static/media/noData.82f07362.svg";